/**
 * Settings Configuration
 * Defines what settings can be stored in localStorage
 */

export const settingsConfig = {


  matchPattern: {
    key: 'match_pattern',
    description: 'Text to search for in activity titles to find last waxing date',
    type: 'string',
    defaultValue: '(chain)',
    validation: {
      required: true
    }
  },

  waxIntervalDistance: {
    key: 'wax_interval_distance',
    description: 'Distance between chain waxes in kilometres',
    type: 'number',
    defaultValue: 500,
    validation: {
      required: true
    }
  },

  gearId: {
    key: 'gear_id',
    description: 'Strava gear ID for tracking',
    type: 'string',
    defaultValue: 'b14928812',
    validation: {
      required: true
    }
  },
};

/**
 * Get default values for all settings
 */
export const getDefaultSettings = () => {
  const defaults = {};
  Object.values(settingsConfig).forEach(setting => {
    defaults[setting.key] = setting.defaultValue;
  });
  return defaults;
};

/**
 * Get setting configuration by key
 */
export const getSettingConfig = (key) => {
  return Object.values(settingsConfig).find(setting => setting.key === key);
};
